import DatePicker from '@/components/DatePicker'
import PropTypes from 'prop-types';
import OverViewFilterSelect from '@/dsComponents/select/OverViewFilterSelect';

const OverViewFilter = (props) => {
	const {
		startDate,
		setStartDate,
		endDate,
		setEndDate,
		auditPageByTab,
		setAuditPageByTab,
		auditAction,
		setAuditAction,
		auditStatus,
		setAuditStatusFn,
		resetFilter } = props
	return (
		<>
			<div className="overview_filter" data-testid="overview-filter-container">
				<div className="overview_filter__cols">
				<div className="overview_filter__col">
						<div className="overview_filter__col__top overview_filter__col__title">
							Start Date
						</div>
						<div className="overview_filter__col__bottom">
							<DatePicker
								selectDate={startDate}
								setSelectDate={setStartDate}
								placeHolderText="Select date and time"
								addClass={"date_picker__format--alignment"}
							/>
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top">
							&nbsp;
						</div>
						<div className="overview_filter__col__bottom overview_filter__col__bottom--padding-top-bottom">
							-
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top">
							End Date
						</div>
						<div className="overview_filter__col__bottom">
							<DatePicker
								selectDate={endDate}
								setSelectDate={setEndDate}
								placeHolderText="Select date and time"
								addClass={"date_picker__format--alignment"}
								minDate={new Date(startDate)}
								disable={!startDate}
								minTime={
									(startDate && endDate) ?
										((startDate.getDate() === endDate.getDate()) ?
											new Date(startDate)
											: new Date().setHours(0, 0, 0)) :
										new Date(0, 0, 0)
								}
								maxTime={new Date().setHours(23, 59, 59)}
							/>
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top">
							Page
						</div>
						<div className="overview_filter__col__bottom">
							<OverViewFilterSelect
								data-testid="overview-filter-page"
								items={auditPageByTab}
								onChange={setAuditPageByTab}
							/>
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top overview_filter__col__title">
							Action
						</div>
						<div className="overview_filter__col__bottom">
							<OverViewFilterSelect
								data-testid="overview-filter-action"
								items={auditAction}
								onChange={setAuditAction}
							/>
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top">
							Status
						</div>
						<div className="overview_filter__col__bottom">
							<OverViewFilterSelect
								data-testid="overview-filter-status"
								items={auditStatus}
								onChange={setAuditStatusFn}
							/>
						</div>
					</div>
					<div className="overview_filter__col">
						<div className="overview_filter__col__top">
							&nbsp;
						</div>
						<div className="overview_filter__col__bottom overview_filter__col__title--heavy overview_filter__col__bottom--padding-top-bottom">
							<span role="button" tabIndex={0} onKeyDown={(e) => {if (e.key === 'Enter') resetFilter();}} aria-label="Clear filters button" className="link link--color" onClick={resetFilter}>Clear filters</span>
						</div>
					</div>
				</div>
			</div>
			<div className="overview__content">
				{props.children}
			</div>
		</>
	)
}

OverViewFilter.propTypes = {
	startDate: PropTypes.instanceOf(Date),
	setStartDate: PropTypes.func.isRequired,
	endDate: PropTypes.instanceOf(Date),
	setEndDate: PropTypes.func.isRequired,
	auditPageByTab: PropTypes.array.isRequired,
	setAuditPageByTab: PropTypes.func.isRequired,
	auditAction: PropTypes.array.isRequired,
	setAuditAction: PropTypes.func.isRequired,
	auditStatus: PropTypes.array.isRequired,
	setAuditStatusFn: PropTypes.func.isRequired,
	resetFilter: PropTypes.func.isRequired,
	children: PropTypes.node
};

export default OverViewFilter
